<style scoped lang="scss">
.cons{
  display: none;
}
.service_chan{
  margin-bottom: 20px;
  display: flex;
  overflow: auto;
  justify-content: space-around;
  li{
    width: 190px;
    height: 188px;
    //margin-right:100px;
    background: url("../../assets/img/产品及服务/fuwu.jpg") no-repeat!important;
    background-size: auto!important;
    .img{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    p{
      font-size: 16px;
      color:#4e4e4e;
      margin-bottom: 10px;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .liaojie{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      color:#959595;
      cursor: pointer;
    }
  }
  li:hover{
    background: url("../../assets/img/产品及服务/fuwu1.jpg") no-repeat!important;
    background-size: auto!important;
    p{
      color: #fff;
    }
    .liaojie{
      color: #fff;
    }
  }
  li:last-child{
    margin-right: 0;
  }
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .cons{
    display: block!important;
  }
  .con{
    display: none!important;
  }
}
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 50px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
//.effect-lists1{
//  //display: block!important;
//  justify-content: center;
//  flex-wrap:wrap;
//  overflow: auto;
//}
.compose-type1{
  padding-bottom: 50px;
  //background: url("../../assets/img/产品及服务/基因调控/基因编辑/ys_bg.png") no-repeat;
  //background-size: 100% 100%;
}
.compose-type2{
  padding-bottom: 50px;
  background: url("../../assets/img/产品及服务/基因调控/基因编辑/ys_bg.png") no-repeat;
  background-size: 100% 100%;
}
.required{
  background: none!important;
  margin-left: 0!important;
  margin-top: 80px;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner con" v-if="!$route.meta.invisibles">
      <img src="@/assets/img/产品及服务/全基因组合成/PCR克隆/banner2.jpg" class="img-fluid" alt="擎科生物-PCR克隆">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons" v-if="!$route.meta.invisibles">
      <img src="@/assets/img/产品及服务/全基因组合成/PCR克隆/banner2_2.jpg" class="img-fluid" alt="擎科生物-PCR克隆">
      <div class="info"></div>
    </div>
    <section v-if="!$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container" style="margin-bottom: 30px;">
        <p class="desc">PCR 克隆技术不依赖于载体的酶切位点，能够根据客户提供的模板序列，设计扩增引物，将目的基因片段直接克隆至任何载体的指定位点，并测序验证，故相比于普通克隆大大节省了时间。</p>
        <p class="desc">PCR 克隆在进行克隆的过程中就 DNA 片段的两端引物结合区可以引入序列修饰，因而适用范围更广，相应的实验难度也更高一些。</p>
      </div>
      <div class="container">
        <div class="c-title con">服务流程</div>
        <div class="c-title cons">服务流程</div>
        <div class="container con">
          <div style="width: fit-content;margin-left: auto;margin-right: auto;"><img src="@/assets/img/产品及服务/全基因组合成/PCR克隆/3.jpg" alt="擎科生物-PCR克隆服务流程
"></div>
          <div style="width: fit-content;margin-left: auto;margin-right: auto;margin-top: 10px;"><img src="@/assets/img/产品及服务/全基因组合成/PCR克隆/4.jpg" alt="擎科生物-PCR克隆服务流程
"></div>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <div style="width: 100%;margin-left: auto;margin-right: auto;"><img src="@/assets/img/产品及服务/全基因组合成/PCR克隆/3_2.jpg" class="img-fluid" alt="擎科生物-PCR克隆服务流程
"></div>
          <div style="width: 100%;margin-left: auto;margin-right: auto;margin-top: 10px;"><img src="@/assets/img/产品及服务/全基因组合成/PCR克隆/4_2.jpg" class="img-fluid" alt="擎科生物-PCR克隆服务流程
"></div>
        </div>
      </div>
      <div class="compose-type1" style="margin-top: 30px;">
        <div class="container">
          <div class="c-title">服务周期</div>
          <div class="tables" >
            <el-table
              border
              class="method-table"
              :span-method="objectSpanMethod"
              :data="tableData">
              <el-table-column
                prop="method1"
                label="基因全长">
              </el-table-column>
              <el-table-column
                prop="method2"
                label="交货周期(工作日)">
              </el-table-column>
              <el-table-column
                prop="method3"
                label="价格">
              </el-table-column>
              <el-table-column
                prop="method4"
                label="QC类型">
              </el-table-column>
              <el-table-column
                prop="method5"
                label="发货形式">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="compose-type2">
        <div class="container">
          <div class="c-title">服务优势</div>
          <div class="neirong con" style="display: flex">
            <div class="left ">
              <img src="@/assets/img/产品及服务/全基因组合成/PCR克隆/优势1.jpg" class="img-fluid" alt="擎科生物-PCR克隆服务优势
">
            </div>
            <div class="right">
              <div class="required">
                <p class="mb20">1.快速：重组反应仅需要 15 min;</p>
                <p class="mb20">2.简单：不受片段酶切位点的影响，无需对片段酶切;</p>
                <p class="mb20">3.高效：阳性率可达 95% 以上;</p>
                <p>4.无缝：不引入额外的序列。</p>
              </div>
            </div>
          </div>
          <div class="neirong cons" >
              <div class="required">
                <p class="mb10">1.快速：重组反应仅需要 15 min;</p>
                <p class="mb10">2.简单：不受片段酶切位点的影响，无需对片段酶切;</p>
                <p class="mb10">3.高效：阳性率可达 95% 以上;</p>
                <p>4.无缝：不引入额外的序列。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="container con">
        <div class="c-title">应用方向</div>
        <div class="neirong">
          <div class="neirong1">
            <h3>1.DNA 重组</h3>
            <p class="desc" style="text-indent: 0">在分子生物学研究中，可以通过PCR克隆技术在体外将不同来源的特异基因或 DNA 片段插入病毒、质粒或其他载体，构建重组DNA分子，再导入到受体细胞中进行扩增和繁殖，经过筛选，把含有目的基因的转化子细胞再扩增提取获得大量DNA。</p>
          </div>
          <div class="neirong1" style="margin-top: 20px;">
            <h3>2.基因定量检测</h3>
            <p class="desc" style="text-indent: 0">PCR克隆技术可以定量监测标本中靶基因的拷贝数，将目的基因和一个单拷贝的参照基因置于同一个试管中进行PCR克隆。电泳分离后观察条带强度，或在引物5’端标记放射性核素，通过检测两条带放射性强度来检测基因拷贝数。</p>
          </div>
        </div>
      </div>
      <div class="container cons">
        <div class="c-title">应用方向</div>
        <div class="neirong">
          <div class="neirong1">
            <p>1.DNA 重组</p>
            <p class="desc" style="text-indent: 0">在分子生物学研究中，可以通过PCR克隆技术在体外将不同来源的特异基因或 DNA 片段插入病毒、质粒或其他载体，构建重组DNA分子，再导入到受体细胞中进行扩增和繁殖，经过筛选，把含有目的基因的转化子细胞再扩增提取获得大量DNA。</p>
          </div>
          <div class="neirong1" style="margin-top: 20px;">
            <p>2.基因定量检测</p>
            <p class="desc" style="text-indent: 0">PCR克隆技术可以定量监测标本中靶基因的拷贝数，将目的基因和一个单拷贝的参照基因置于同一个试管中进行PCR克隆。电泳分离后观察条带强度，或在引物5’端标记放射性核素，通过检测两条带放射性强度来检测基因拷贝数。</p>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="c-title">相关服务</div>
        <div class="container" style="width: 100%!important;">
          <div class="con">
            <ul class="effect-lists service_chan">
              <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
                <img :src="`/static/img/fenzi_${item.img}${currentType===index ? '' : '_active'}.png`" >
                <p style="margin-top: 10px;">{{item.name}}</p>
                <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
              </li>
            </ul>
          </div>
          <div class="cons" style="margin-top: 20px;">
            <ul class="effect-lists service_chan">
              <li v-for="(item, index) in types" :key="index" class="pointer"   @click="$router.push(item.ref)">
                <img :src="`/static/img/fenzi_${item.img}${currentType===index ? '' : '_active'}.png`" style="width: 55px;height: 55px;">
                <p style="margin-top: 10px;">{{item.name}}</p>
                <div class="liaojie" @click="$router.push(item.ref)">了解更多></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      tableData:[
        {
          method1:'<1kb',
          method2:'5-7',
          method3:'电话或邮件咨询',
          method4:'测序结果 COA报告(含琼脂糖凝胶检测图及产物基因信息)',
          method5:'冻干质粒DNA一管(约4ug/管),含有相应质粒的甘油菌或穿刺菌一管',
        },
        {
          method1:'1kb-2kb',
          method2:'9-12',
          method3:'',
          method4:'',
          method5:'',
        },
        {
          method1:'2kb-3kb',
          method2:'12-15',
          method3:'',
          method4:'',
          method5:'',
        },
        {
          method1:'>3000bp',
          method2:'需分析序列',
          method3:'',
          method4:'',
          method5:'',
        },
      ],
      types: [
        {name: '基因合成', img: '2', ref: '/tec/gen_compose'},
        {name: '引物合成', img: '1', ref: '/tec/compose'},
        {name: '基因检测', img: '6', ref: '/products/Gene'},
        {name: '常规分子项目', img: '5', ref: '/products/Conventional_molecular_project'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {  //表格合并行
      if (columnIndex === 2) {
        return {
          rowspan: 4,
          colspan: 1
        }
      }
      if (columnIndex === 3) {
        return {
          rowspan: 4,
          colspan: 1
        }
      }
      if (columnIndex === 4) {
        return {
          rowspan: 4,
          colspan: 1
        }
      }
    },
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/PCR_cloning.vue